import { render, staticRenderFns } from "./ConfigControls.vue?vue&type=template&id=78795597&"
import script from "./ConfigControls.vue?vue&type=script&lang=js&"
export * from "./ConfigControls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports